import BrandInfo from "../pages/BrandIntro";
import Cart from "../pages/Cart";
import CommonIssue from "../pages/CommonIssue";
import ForgotPassword from "../pages/ForgotPassword";
import HiddenStore from "../pages/HiddenStore";
import Home from "../pages/Home";
import ProductDetailPage from "../pages/Home/components/ProductDetailPage";
import InMaintenance from "../pages/InMaintenance";
import InstallGuide from "../pages/InstallGuide";
import ModifySuccess from "../pages/ModifySuccess";
import NotFoundPage from "../pages/NotFoundPage";
import OrderReceipt from "../pages/OrderReceipt";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import ReturnAndExchangePolicy from "../pages/ReturnAndExchangePolicy";
import SignUp from "../pages/SignUp";
import Signin from "../pages/Signin";
import Terms from "../pages/Terms";
import UserCenter from "../pages/UserCenter";
import Verification from "../pages/Verification";
// navType { hideHeader, hideFooter }
const RouterList = [
  {
    path: "/",
    name: "home",
    component: Home,
    navType: {
      // hideHeader: true,
    },
  },
  {
    path: "/product",
    name: "product",
    component: ProductDetailPage,
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUp,
  },
  {
    path: "/signin",
    name: "signin",
    component: Signin,
  },
  {
    path: "/commonissue",
    name: "commonissue",
    component: CommonIssue,
  },
  {
    path: "/verify",
    name: "verify",
    component: Verification,
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/success",
    name: "success",
    component: ModifySuccess,
  },
  {
    path: "/usercenter",
    name: "usercenter",
    component: UserCenter,
  },
  {
    path: "/cart",
    name: "cart",
    component: Cart,
  },
  {
    path: "/orderreceipt",
    name: "orderreceipt",
    component: OrderReceipt,
    navType: {
      hideHeader: true,
      hideFooter: true,
      hideFloatButton: true,
      backgroundColor: "var(--grey)",
    },
  },
  {
    path: "/brand",
    name: "brand",
    component: BrandInfo,
  },
  {
    path: "/installguide",
    name: "installguide",
    component: InstallGuide,
  },
  {
    path: "/terms",
    name: "terms",
    component: Terms,
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/returnandexchange",
    name: "returnandexchange",
    component: ReturnAndExchangePolicy,
  },
  {
    path: "/inMaintenance",
    name: "inMaintenance",
    component: InMaintenance,
    navType: {
      hideHeader: true,
      hideFooter: true,
      backgroundColor: "var(--grey)",
    },
  },
  {
    path: "/check",
    name: "hiddenStore",
    component: HiddenStore,
  },
  {
    path: "*",
    name: "404",
    component: NotFoundPage,
  },
];
export default RouterList;
